import { Outlet } from 'react-router';
import { TabbedLayout } from '@/modules/application/layouts/TabbedLayout';
import { TabbedLayoutTopBar } from '@/modules/application/components/TabbedLayoutTopBar';
import { SwapHorizRounded } from '@mui/icons-material';
import { LayoutActionsProvider } from '@/providers/layout-actions-provider/LayoutActionsProvider';
import { useTranslation } from '@/lib';

export default function TransactionsLayout() {
  const { t } = useTranslation();
  const transactionTabItems = [
    {
      activeRouteIds: ['/app/transactions', '/app/transactions/overview'],
      label: t('overview'),
      url: '/app/transactions/overview',
    },
  ];

  return (
    <LayoutActionsProvider>
      <TabbedLayout
        topBar={
          <TabbedLayoutTopBar
            header={t('transactions')}
            headerIcon={<SwapHorizRounded fontSize={'small'} />}
            tabItems={transactionTabItems}
          />
        }
      >
        <Outlet />
      </TabbedLayout>
    </LayoutActionsProvider>
  );
}
